import { DateTime } from 'luxon';
import { ForDevice, ForUser, NumericPaymentStatInfo, SaleTags } from 'types';

interface RangeParams {
  from: DateTime;
  to: DateTime;
}

interface BaseGetSalesParams extends RangeParams {
  limit: number;
  next?: string;
}

export type GetSalesParams = BaseGetSalesParams & (ForUser | ForDevice);

export type GetSalesSumParams = RangeParams & (ForUser | ForDevice);

export type GetSalesDynamicsParams = ForUser & { months: number };

export interface Currency {
  Code: string;
  Sign: string;
}

export enum SaleWaterType {
  Osmos = 0,
  Mineral = 1, // Минеральная
  WaterType2 = 2, // Газированная (Резерв)
  WaterType3 = 3, // Охлажденная (Резерв)
  WaterType4 = 4, // Горячая (Резерв)
  Ozon = 8, // Озон
  Bottle = 16 // Бутылка
}

export interface SalesItem extends NumericPaymentStatInfo {
  DeviceId?: string;
  Amount: number;
  DeviceTimestamp: number;
  DeviceLocalTime: string;
  Dt: number;
  SId: string;
  Litres: number;
  Moneypured: number;
  Tags?: SaleTags[];
  // @deprecated use WaterType instead
  IsMineral: boolean;
  WaterType: SaleWaterType;
  // если связка устройств, то может быть лейбл
  // см. https://tracker.yandex.ru/DEVELOPMENT-191
  DeviceLabel?: string;
}

export interface SalesResponse {
  Currency: Currency;
  Items: SalesItem[];
  Next: string;
  next: string;
}
